import { serializeObject, setNamedProperties } from '../../util/general';

export default class ContactMethodModel {
  constructor(props) {
    this.id = null;
    this.type = null;
    this.summary = null;
    this.self = null;
    this.htmlUrl = null;
    this.label = null;
    this.address = null;
    this.countryCode = null;
    this.sendShortEmail = false;
    this.sendHtmlEmail = false;
    this.setProperties(props);
  }

  setProperties(props) {
    const contactMethodProperties = [
      'id', 'type', 'summary', 'self', 'html_url', 'label',
      'address', 'country_code', 'send_short_email', 'send_html_email'
    ];
    setNamedProperties(this, props, contactMethodProperties);
  }

  asJSON() {
    return serializeObject(this);
  }

  asObject() {
    const props = [
      'id', 'type', 'summary', 'self', 'htmlUrl', 'label',
      'address', 'countryCode', 'sendShortEmail', 'sendHtmlEmail'
    ];
    return props.reduce((result, prop) => {
      const obj = result;
      obj[prop] = this[prop];
      return obj;
    }, {});
  }
}
